<template>
  <div class="login-container">
    <!-- <div class="header-container">
      <div class="header">
        <span class="title">道路安全监测管理系统</span>
      </div>
    </div> -->

    <div class="form-container">
      <div class="title">
        道路安全监测管理系统
      </div>
      <el-input
        v-model="username"
        placeholder="请输入账号"
        clearable
        @keyup.enter.native="loginClickHandler"
      />
      <br>
      <el-input
        v-model="password"
        type="password"
        placeholder="请输入密码"
        style="margin: 30px 0 40px;"
        clearable
        @keyup.enter.native="loginClickHandler"
      />
      <br>
      <el-button
        type="primary"
        :loading="loaded"
        @click="loginClickHandler"
      >
        登录
      </el-button>
    </div>

    <img src="/static/img/login/wx.png" class="wx">
  </div>
</template>

<script>
import { value, computed, onMounted } from 'vue-function-api'

import { pages } from '@/config'

export default {
  name: 'Login',
  data () {
    return {}
  },
  setup (
    props,
    {
      root: { $store, $router },
    }
  ) {
    let storage = window.localStorage
    const username = value(storage.getItem('username'))
    const password = value('')

    const loaded = computed(() => $store.state.loaded)

    onMounted(() => {
      loaded && $router.push(pages.home.path)
    })

    function loginClickHandler () {
      // console.log(username)
      $store.dispatch('pageLogin', {
        username: username.value,
        password: password.value,
      })
    }

    return {
      username,
      password,
      loaded,
      systemName: process.env.VUE_APP_SYSTEM_NAME,
      loginClickHandler,
    }
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/static/style/common';

.login-container {
  height: 100vh;
  background: url('/static/img/login/bk.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  min-width: 1200px;
  min-height: 675px;
  overflow: auto;

  .header-container {
    height: 60px;
    background-image: linear-gradient(
      #252980 0%,
      #2a3794 20%,
      #2c42a1 40%,
      #2f49ac 60%,
      #304caf 100%
    );
  }

  // .header {
  //   position: relative;
  //   font-size: 16px;
  //   color: #ffffff;
  //   background: url(/static/img/common/header.png) no-repeat;
  //   background-size: 100% 100%;
  //   height: 80px;
  //   margin-right: 50px;

  //   &:before {
  //     content: url(/static/img/login/logo.png);
  //     margin-left: 40px;
  //     position: relative;
  //     top: 9px;
  //   }

  //   .title {
  //     font-size: 28px;
  //     font-weight: bold;
  //     position: absolute;
  //     left: 50%;
  //     top: 50%;
  //     background-image: linear-gradient(to right, #87cefe, #e3f7ff, #87cefe);
  //     background-clip: text;
  //     -webkit-text-fill-color: transparent;
  //     transform: translate(-50%, -70%);
  //   }
  // }

  .form-container {
    box-sizing: border-box;
    // max-width: 756px;
    // max-height: 462px;
    width: 630px;
    height: 385px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -315px;
    margin-top: -240px;
    // transform: translateX(-50%);
    background: url(/static/img/login/bkIcon.png) no-repeat;
    background-size: cover;
    // padding: 130px 0 0;
    text-align: center;

    .title {
      margin-top: 45px;
      font-size: 28px;
      font-weight: bold;
      background-image: linear-gradient(to right, #87cefe, #e3f7ff, #87cefe);
      background-clip: text;
      -webkit-text-fill-color: transparent;

      &:after {
        content: url(/static/img/login/line.png);
        padding: 10px 0 25px;
        display: inline-block;
      }
    }

    .el-input {
      width: 260px;
      /deep/ .el-input__inner {
        background-color: transparent;
        border-radius: 10px;
        border: 2px solid #3787ff;
        color: #fff;
        font-size: 15px;
        height: 44px;
        padding-left: 20px;

        &::-webkit-input-placeholder {
          color: #a3a3a3;
        }

        &:-moz-placeholder {
          color: #a3a3a3;
        }

        &:-ms-input-placeholder {
          color: #a3a3a3;
        }
      }

      /deep/ .el-input__prefix {
        left: 10px;
      }
    }

    .el-button {
      font-size: 18px;
      padding: 12px;
      width: 260px;
      border-radius: 10px;
      background: linear-gradient(0deg, #1849fc 0%, #2a91ff 100%);
      border: none;
      transition: all 1s;

      &:hover {
        background: linear-gradient(0deg, #2c56eb 0%, #5ea0e7 100%);
      }
    }
  }
  .wx {
    position: absolute;
    bottom: 9%;
    right: 9%;
    max-width: 375px;
    min-width: 300px;
    width: 25%;
  }
}
</style>
